import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { useSelector } from 'react-redux';
import ids from '../../QestIds';
import { FdMeasurementApplication } from '../types';
import {
  BsEmbeddedMoistureContent,
  BsMeasurementSection,
  BsPreparationSection,
  BsReferenceDensitySection,
  BsResultsSection,
  BsRetestSection,
} from './Sections';

const qestids = [ids.nuclearFieldDensity.BS_1377_9_Clause_2_5.rev1990];

let Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const measurementApplication = useSelector(createWorksheetSelector!('Preparation.MeasurementApplication'));
  let shouldShowRetestAndMDDSection = measurementApplication === FdMeasurementApplication.ComplianceTest;
  return (
    <>
      <BsPreparationSection />
      {shouldShowRetestAndMDDSection && (
        <>
          <BsRetestSection />
          <BsReferenceDensitySection />
        </>
      )}
      <BsMeasurementSection />
      <BsEmbeddedMoistureContent />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <BsResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

Worksheet.qestIds = qestids;
const BsNuclearFieldDensityWorksheet = withInjectedProps(Worksheet);

export { BsNuclearFieldDensityWorksheet };
export default BsNuclearFieldDensityWorksheet;
